import script from "./HonorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./HonorsView.vue?vue&type=script&setup=true&lang=js"

import "./HonorsView.vue?vue&type=style&index=0&id=1715ffd4&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/spepi.cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1715ffd4"]])

export default __exports__